export default "__VITE_ASSET__CoRc9ZSC__"